module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/confirmed-account-mobile-d09d6f3e061a3d54152a9e2d327c6eb3.jpeg";